import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    nonceField: window.nonceField,
    pluginPath: window.pluginPath,
    mediaType: (() => {
        if (window.innerWidth >= 768) {
            return "desktop";
        } else {
            return "mobile";
        }
    })()
};

const appSettingsSlice = createSlice({
    name: "appSettings",
    initialState,
    reducers: {
        
    }
});

export default appSettingsSlice.reducer;